__turbopack_context__.v({
  "active": "header-module-scss-module__wL-RSW__active",
  "activeLink": "header-module-scss-module__wL-RSW__activeLink",
  "beta": "header-module-scss-module__wL-RSW__beta",
  "burgerButton": "header-module-scss-module__wL-RSW__burgerButton",
  "cfrVariant": "header-module-scss-module__wL-RSW__cfrVariant",
  "headerContainer": "header-module-scss-module__wL-RSW__headerContainer",
  "headerContent": "header-module-scss-module__wL-RSW__headerContent",
  "headerScroll": "header-module-scss-module__wL-RSW__headerScroll",
  "headerTopRow": "header-module-scss-module__wL-RSW__headerTopRow",
  "hideMarketDataBtnWithOpenedSearchMenu": "header-module-scss-module__wL-RSW__hideMarketDataBtnWithOpenedSearchMenu",
  "hideSearchOnMobileView": "header-module-scss-module__wL-RSW__hideSearchOnMobileView",
  "iconContainer": "header-module-scss-module__wL-RSW__iconContainer",
  "iconContainerPremiumization": "header-module-scss-module__wL-RSW__iconContainerPremiumization",
  "innerMenuWrapper": "header-module-scss-module__wL-RSW__innerMenuWrapper",
  "link": "header-module-scss-module__wL-RSW__link",
  "linksButtonsContainer": "header-module-scss-module__wL-RSW__linksButtonsContainer",
  "linksWrapper": "header-module-scss-module__wL-RSW__linksWrapper",
  "menuOpenedOnMobileView": "header-module-scss-module__wL-RSW__menuOpenedOnMobileView",
  "new": "header-module-scss-module__wL-RSW__new",
  "panelLink": "header-module-scss-module__wL-RSW__panelLink",
  "premiumizationLinksContainer": "header-module-scss-module__wL-RSW__premiumizationLinksContainer",
  "searchResultOpenedOnMobileView": "header-module-scss-module__wL-RSW__searchResultOpenedOnMobileView",
  "solutionsButton": "header-module-scss-module__wL-RSW__solutionsButton",
  "spinner": "header-module-scss-module__wL-RSW__spinner",
  "spinnerOverlay": "header-module-scss-module__wL-RSW__spinnerOverlay",
  "title": "header-module-scss-module__wL-RSW__title",
  "toolbarContainer": "header-module-scss-module__wL-RSW__toolbarContainer",
  "transparentBackground": "header-module-scss-module__wL-RSW__transparentBackground",
  "userProPlan": "header-module-scss-module__wL-RSW__userProPlan",
  "withoutLogin": "header-module-scss-module__wL-RSW__withoutLogin",
});
